import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.609097 961.619254\" p-id=\"8178\" /><path d=\"M662.268422 511.010463 280.997835 892.299469c-14.785751 14.808264-14.785751 38.796608 0 53.562916 14.788821 14.807241 38.776142 14.807241 53.584406 0l408.226518-408.230612c14.789844-14.790868 14.789844-38.777165 0-53.585429-1.01512-1.020236-2.099824-1.976004-3.206018-2.843768L333.797365 75.350129c-14.808264-14.788821-38.795585-14.788821-53.607942 0-14.762215 14.808264-14.762215 38.796608 0 53.585429L662.268422 511.010463 662.268422 511.010463 662.268422 511.010463zM662.268422 511.010463\" p-id=\"8179\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/global/right.svg
// module id = 5R/3
// module chunks = 55